export default __webpack_public_path__ + "static/media/maze-left.25d123a3.svg";